// extracted by mini-css-extract-plugin
module.exports = {"LogoutTitle":"Logout_LogoutTitle__oBKHa","LogoutSubTitle":"Logout_LogoutSubTitle__1Qmzs","LoginButton":"Logout_LoginButton__32eC4"};